import { createContext } from "react";

import type { FinanceOverviewData } from "@workspace/accounting/reporting/types";
import type { AppInstance } from "@workspace/app-instance";
import type {
	Operation,
	OperationItem,
	Operations,
} from "@workspace/operations";
import type { ProductCatalogData } from "@workspace/product-catalog/types";
import type { Profile } from "@workspace/profile";

import type { StaffingData, StaffMember, StaffRole } from "../../types";

export type VenueDetails = {
	id: string;
	name: string;
	timeZone: string;
	currencies: string[];
	defaultCurrency: string;
	status: string;
	tradingHours: string;
};

export type ApiResponse = {
	venueId: string;
	venueDetails: VenueDetails;
	data: {
		financial?: FinanceOverviewData;
		overview?: unknown;
		stock?: unknown;
		staff?: StaffingData;
		screen?: unknown;
		payroll?: unknown;
		tax?: unknown;
		shareholder?: unknown;
		productCatalog?: ProductCatalogData;
	};
} & Operations;

export interface VenueDashboardContext {
	tenant: string;
	venueId: string;
	appInstance: OperationItem<AppInstance>;
	profile: Profile;
	operations: Operation[];

	data: ApiResponse | undefined | null;

	section: string;
	setSection: (tab: string) => void;

	locationLabel: string;

	sync: (section?: string) => Promise<void>;
	fetch:
		| ((section?: string) => Promise<void>)
		| ((section?: string | undefined) => void);

	showStaffing: boolean;
	staffing: {
		current:
			| (Omit<StaffMember, "role"> & {
					role: StaffRole;
			  })
			| null;

		data?: StaffingData;
	};
	showEmployeeCentre: boolean;

	showOverview: boolean;
	overview: {
		// data?: OverviewData;
		data?: unknown;
	};
	showFinancial: boolean;
	showStock: boolean;
	stock: {
		// data?: StockData;
		data?: unknown;
	};
	/**
	 * HA-584. Distinct from `showStock`, which gates the stock WIDGET on the dashboard
	 * (`venue-management:dashboard:stock:view`). This one gates the Stock management AREA on
	 * `stock:view`, which Staff deliberately do not hold — they hold `stock:86:set` only (D-HA-8).
	 */
	showStockManagement: boolean;
	/** HA-647: the venue's Orders (read-only). `venue-management-view-venue-orders` = `venue:orders:view`. */
	showOrders: boolean;
	showPayroll: boolean;
	showTax: boolean;
	showScreens: boolean;
	screens: {
		data?: unknown;
		// data?: ScreenData;
	};
	showShareholder: boolean;

	showProducts: boolean;
	productCatalog: {
		data?: ProductCatalogData;
	};

	showSettings: boolean;
	showSecurity: boolean;
	showKiosk: boolean;

	hasAccess: (section: string) => boolean;
}

export const VenueDashboardContext = createContext<
	VenueDashboardContext | undefined
>(undefined);
